<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h2>User Logins</h2>
      <v-divider></v-divider>
      <div class="row">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">User Name</th>
                  <th class="text-left">Device Name</th>
                  <th class="text-left">Device ID</th>
                  <th class="text-left">MAC Address</th>
                  <th class="text-left">Login At</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.UserName }}</td>
                  <td>{{ item.DeviceName }}</td>
                  <td>{{ item.DeviceID }}</td>
                  <td>{{ item.MACAddress }}</td>
                  <td>{{ item.createDateTime | formatDateTime }}</td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";

export default {
  name: "UserLogins",
  props: {
    //userId: { type: Number, required: true },
  },
  components: {
    Notification,
    Pagination,
  },
  created() {
    this.getLoginLogsByPagin();
  },
  methods: {
    getLoginLogsByPagin() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("logger", this.paging)
          .then((response) => {
            that.overlay = false;
            resolve(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            console.log(this.list);
            
          })
          .catch((error) => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getLoginLogsByPagin();
    },
  },
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "", orderColumn: 'createDateTime', isASC: false  },
      overlay: false
    };
    
  },
};
</script>




// WEBPACK FOOTER //
// src/components/UserLogins.vue